import { Api } from '@/modules/common';
import config from '@/app/editor/config';

export const gemMeterServices = {
  apiRating: (star: number): Promise<{}> => {
    return Api.base.post('/rating', { star });
  },

  apiGetImages: (): Promise<{}> => {
    const $gfFrame = jQuery('#gfFrame');
    const shop = $gfFrame.data('gfframe').getShopDomain() ?? window.___gemShopInfo?.shopifyDomain;
    const dataReq = {
      shop: shop,
      app_name: 'gempages',
    };
    const _uploadDomain = config.__DOMAIN_UPLOAD();
    return Api.base.post(_uploadDomain + '/api/image/get', dataReq);
  },
};
